module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "eth"
    }
  }), _vm._v("ETHNOMUSICOLOGY MULTIMEDIA SERIES PREFACE")]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_vm._v("GUIDE TO ONLINE MEDIA EXAMPLES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Each of the audio, video, or still image media examples listed herein is associated with specific passages in this book, and each example has been assigned a unique persistent uniform resource locator, or "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(". The "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" identifies a specific audio, video, or still image media example on the Ethnomusicology Multimedia website, "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ethnomultimedia.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ethnomultimedia.org")])]), _vm._v(". Within the text of the book, a "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" number in parentheses functions like a citation and immediately follows the text to which it refers, for example ("), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pur3.1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 3.1")]), _vm._v("). The numbers following the word "), _c('em', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")])]), _vm._v(" relate to the chapter in which the media example is found, and the number of "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v("s contained in that chapter. For example, "), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pur3.1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 3.1")]), _vm._v(" refers to the first media example found in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pur3.2"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 3.2")]), _vm._v(" refers to the second media example found in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(", and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To access all media associated with this book, readers must first create a free account by going to the Ethnomusicology Multimedia Project website "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ethnomultimedia.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ethnomultimedia.org")])]), _vm._v(" and clicking the sign in link. Readers will be required to read and electronically sign an end users license agreement the first time they access a media example on the website. After logging in to the site, there are two ways to access and play back audio, video, or still image media examples. In the search field enter the name of the author to be taken to a webpage with information about the book and the author as well as a playlist of all media examples associated with the book. To access a specific media example, in the search field enter the six-digit "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" identifier of the example (the six digits located at the end of the full "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" address). The reader will be taken to the web page containing that media example as well as a playlist of all the other media examples related to the book. Readers of the electronic edition of this book will simply click on the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" address for each media example; once they have logged in to "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ethnomultimedia.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ethnomultimedia.org")])]), _vm._v(", this live link will take them directly to the media example on the Ethnomusicology Multimedia website.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("LIST OF PURLS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2b"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur1.1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 1.1 | Uzeyir Hajibeyli, Koroghlu’s aria from the opera "), _c('em', [_vm._v("Koroghlu")]), _vm._v(". Performed by Bulbul. Excerpt from the documentary "), _c('em', [_vm._v("To My Dear People")]), _vm._v(". Baku Studio, 1954. Video. Courtesy: Polad Bulbuloghlu.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910342",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910342")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur1.2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 1.2 | Nazim Aliverdibeyov, "), _c('em', [_vm._v("Bayati Shiraz")]), _vm._v(" for organ. Performed by Rena Ismayilova. Colon, St. Joseph Church, 2008. Audio. Courtesy: Samir Aliverdibeyov and Rena Ismayilova.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910343",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910343")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur1.3"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 1.3 | Duo “Quis Est Homo, Qui Non Fleret,” from "), _c('em', [_vm._v("Stabat Mater")]), _vm._v(", by Gioachino Rossini. Performed by Fidan Gasimova, Khuraman Gasimova, and the Azerbaijan State Symphony Orchestra named after Uzeyir Hajibeyli. Rauf Abdullayev, conductor. Baku, the Heydar Aliyev Palace, April 21, 2000. Video. Courtesy: Khuraman Gasimova.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910344",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910344")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur1.4"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 1.4 | Azerbaijani folk song “She Has Got a House with Tiny Rooms,” arranged by Fikrat Amirov. Performed by Fidan Gasimova, Khuraman Gasimova, and the Azerbaijan State Symphony Orchestra named after Uzeyir Hajibeyli. Rauf Abdullayev, conductor. Baku, the Heydar Aliyev Palace, April 21, 2000. Video. Courtesy: Khuraman Gasimova.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910345",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910345")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur1.5"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 1.5 | Haji Khanmammadov. Concerto for the "), _c('em', [_vm._v("Kemancha and Symphony Orchestra")]), _vm._v(" (second movement). Performed by The Youth Music Monterrey County symphony orchestra from California. Farkhad Khudyev, conductor. Imamyar Hasanov, kemancha soloist. Sunset Center, Carmel-by-the-Sea, November 9, 2013. Video. Courtesy: Youth Music Monterey County.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910346",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910346")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "pur3.1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 3.1 | Elmira Nazirova, Sonata for Cello and Piano, movements 2, 3, and 4. Performed by Isaak Turich and Elmira Nazirova. Baku, 1954. Audio. Courtesy: Elmar Fel and Mikhail Turich.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910347",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910347")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "pur3.2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 3.2 | Fikrat Amirov and Elmira Nazirova, Concerto on Arab Themes for the Piano and Symphony Orchestra, excerpt from the first movement. Performed by the Royal Philharmonic Concert Orchestra at Caspian Corridor Gala. Yalchin Adigozalov, conductor. Yegana Akhundova, soloist. London, Westminster, Central Hall, March 7, 2014. Video. Courtesy: Royal Philharmonic Concert Orchestra.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910348",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910348")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("CHAPTER 4")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "pur4.1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 4.1 | Uzeyir Hajibeyli, Chorus “Night of Separation” from the opera "), _c('em', [_vm._v("Leyli and Majnun")]), _vm._v(". Performed by the International Vocal Ensemble of Indiana University. Artistic Director Katherine Domingo. Aida Huseynova, pianist. Auer Hall, April 20, 2008. Audio. Courtesy: Indiana University Jacobs School of Music.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910349",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910349")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur4.2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 4.2 | Uzeyir Hajibeyli, “Arazbari” from the opera "), _c('em', [_vm._v("Leyli and Majnun")]), _vm._v(". Performed by the Azerbaijan State Chamber Orchestra named after Gara Garayev. Yashar Imanov, conductor. Audio. Source: Classical Music of Azerbaijan, 6 vols. Vol. 1: Chamber Music. Track 1. Azerbaijan International, AICD1206, 1997, compact disc. Produced jointly by Amoco and Azerbaijan International. "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://azer.com/aiweb/categories/music/AudioPages/CMA/cma_contents.html",
      "target": "_blank"
    }
  }, [_vm._v("http://azer.com/aiweb/categories/music/AudioPages/CMA/cma_contents.html")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910350",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910350")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur4.3"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 4.3 | Uzeyir Hajibeyli, Overture to the opera "), _c('em', [_vm._v("Koroghlu")]), _vm._v(". Performed by the Azerbaijani State Symphony Orchestra named after Uzeyir Hajibeyli. Niyazi, conductor. Baku, the Azerbaijan State Philharmonic Hall named after Muslim Magomayev, 1975. Video. Courtesy: The State Museum of Azerbaijani Musical Culture.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910351",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910351")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur4.4"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 4.4 | Muslim Magomayev, Two arias of Aslanshah from the opera "), _c('em', [_vm._v("Shah Ismayil")]), _vm._v(". Performed by Muslim Magomayev. Excerpt from the documentary “Muslim Magomayev Sings,” produced by Azerbaijanfilm Studio, 1971. Video. Courtesy: Marina Magomayeva and Tamara Siniavskaia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910352",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910352")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur4.5"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 4.5 | Asaf Zeynalli, The romance “My Country.” Performed by Bulbul. Vladimir Kozlov, piano. Baku, 1956. Audio. Courtesy: Polad Bulbuloghlu.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910353",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910353")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("CHAPTER 5")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "pur5.1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 5.1 | Gara Garayev, Pastorale from Sonata for Violin and Piano. Performed by Arif Manafli and Farhad Badalbeyli. Audio. Source: Farhad Badalbeyli, "), _c('em', [_vm._v("My Piano")]), _vm._v(". 2 vols. Baku: AzEuroTel, 2000. Vol. 1, Track 20.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910354",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910354")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur5.2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 5.2 | Fikrat Amirov, Balash’s aria from the opera "), _c('em', [_vm._v("Sevil")]), _vm._v(". Performed by Azer Zeynalov. Production by the Azerbaijan State Opera and Ballet Theater, 2010. Video. Courtesy: Jamil Amirov.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910355",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910355")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur5.3"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 5.3| Fikrat Amirov, "), _c('em', [_vm._v("Kurd Ovshari")]), _vm._v(". Performed by the Azerbaijan State Symphony Orchestra named after Uzeyir Hajibeyli. Yalchin Adigozalov, conductor. Audio. Source: Classical Music of Azerbaijan, 6 vols. Vol. 1. Symphonic Music. Track 2. Azerbaijan International, AICD1201, 1997, compact disc. Produced jointly by Amoco and Azerbaijan International. "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://azer.com/aiweb/categories/music/AudioPages/CMA/cma_contents.html",
      "target": "_blank"
    }
  }, [_vm._v("http://azer.com/aiweb/categories/music/AudioPages/CMA/cma_contents.html")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910356",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910356")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur5.4"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 5.4 | Azerbaijani folk song “Flowers Have Blossomed, Spring Has Come,” arranged by Jahangir Jahangirov. Performed by the International Vocal Ensemble of Indiana University. Artistic Director Katherine Strand. Aida Huseynova, pianist. Auer Hall, April 14, 2013. Audio. Courtesy: Indiana University Jacobs School of Music.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910357",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910357")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur5.5"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 5.5 | Gara Garayev, Waltz from the ballet "), _c('em', [_vm._v("Seven Beauties")]), _vm._v(". Source: film-ballet "), _c('em', [_vm._v("Seven Beauties")]), _vm._v(", Rafiga Akhundova and Magsud Mammadov, choreographers. Azerbaijanfilm Studio, 1982. Video. Courtesy: Faraj Garayev.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910358",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910358")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur5.6"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 5.6 | Arif Malikov, Adagio from the ballet "), _c('em', [_vm._v("The Legend of Love")]), _vm._v(". Source: film-ballet "), _c('em', [_vm._v("The Legend of Love")]), _vm._v(", Iurii Grigorovich, choreographer. Central Television of the USSR, 1969. Video. Courtesy: Arif Malikov and Iurii Grigorovich.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910359",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910359")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("CHAPTER 6")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "pur6.1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.1 | Gara Garayev, Third Symphony, Performed by the Moscow Chamber Orchestra. Rudolf Barshai, conductor. Moscow, 1966. Audio. Courtesy: Faraj Garayev and Walter Barshai.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910360",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910360")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "pur6.2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.2 | Arif Malikov, Sixth Symphony, Performed by the Azerbaijan State Symphony Orchestra named after Uzeyir Hajibeyli. Rauf Abdullayev, conductor. Baku, the Azerbaijan State Philharmonic Hall named after Muslim Magomayev. Baku, November 28, 2014. Audio. Courtesy: Arif Malikov.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910361",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910361")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.3"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.3 | Faraj Garayev, Yalli from the ballet "), _c('em', [_vm._v("The Shadows of Gobustan")]), _vm._v(". Production of the Azerbaijan State Opera and Ballet Theater. Maxine Braham (United Kingdom), choreographer (based on the choreography of Rafiga Akhundova and Magsud Mammadov). The Gobustan State Reserve, May 31, 2013. Video. Courtesy: Faraj Garayev and Maxine Braham.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910362",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910362")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.4"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.4 | Khayyam Mirzazade, The choreographed version of the preludes "), _c('em', [_vm._v("White and Black")]), _vm._v(". Pullumb Agalliu (Albania), choreographer. Gulnara Safarova, pianist. Baku, the Azerbaijan State Opera and Ballet Theater, June 7, 2000. Video. Courtesy: Khayyam Mirzazade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910363",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910363")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.5"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.5 | Khayyam Mirzazade, Sonata for the Violin, "), _c('em', [_vm._v("Pro e Contra")]), _vm._v(". Performed by Sarvar Ganiyev. Audio. Source: Khayyam Kh. Mirzazade, compact disk, Baku: Ministry of Culture of Azerbaijan and Gilan-CD, 2011. Track 1.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910364",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910364")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.6"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.6 | Ismayil Hajibeyov, "), _c('em', [_vm._v("Sketches in the Spirit of Watteau")]), _vm._v(". Performed by Ulviyya Hajibeyova. Audio. Source: Anthology of Azerbaijani Composers, 15 Vols. Baku: Azersun, 2010. Volume1, Track 13.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910365",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910365")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.7"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.7 | Uzeyir Hajibeyli, "), _c('em', [_vm._v("Jangi")]), _vm._v(" for the piano. Performed by Frangiz Hajiyeva. Recorded by Aida Huseynova. Baku Music Academy, January 5, 2014. Audio.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910366",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910366")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.8"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.8 | Ismayil Hajibeyov, Rhapsody for the piano and symphony orchestra. Performed by Farhad Badalbeyli and the Azerbaijan State Symphony Orchestra of the Television and Radio. Ramiz Melikaslanov, conductor. Audio. Source: Farhad Badalbeyli, "), _c('em', [_vm._v("My Piano")]), _vm._v(". 2 vols. Baku: AzEuroTel, 2000. Vol. 2. Track 3.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910367",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910367")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.9"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.9 | Agshin Alizade, "), _c('em', [_vm._v("Jangi")]), _vm._v(". Performed by the Azerbaijan State Chamber Orchestra named after Gara Garayev. Yashar Imanov, conductor. Oleg Grechko, soloist. Audio. Source: Classical Music of Azerbaijan, 6 vols. Vol. 1: Chamber Music. Track 11. Azerbaijan International, AICD1206, 1997, compact disc. Produced "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("jointly by Amoco and Azerbaijan International. "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://azer.com/aiweb/categories/music/AudioPages/CMA/cma_contents.html",
      "target": "_blank"
    }
  }, [_vm._v("http://azer.com/aiweb/categories/music/AudioPages/CMA/cma_contents.html")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910368",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910368")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.10"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.10 | Agshin Alizade, “Two Trees Are Bent Together,” From "), _c('em', [_vm._v("Bayati")]), _vm._v(", for a capella chorus. Performed by the Azerbaijan State Choral Capella of Azerbaijan. Javanshir Jafarov, conductor. Baku, 1984. Audio. Courtesy: Fuad Alizade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910369",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910369")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.11"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.11 | Frangiz Alizade, "), _c('em', [_vm._v("Music for Piano")]), _vm._v(", excerpt. Performed by Frangiz Alizade. Audio. Source: Kronos Quartet. Mugam Sayagi. Music of Franghiz Ali-Zadeh. Nonesuch Records Inc., 79804-2, 2005, compact disc.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910370",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910370")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.12"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.12 | Frangiz Alizade, "), _c('em', [_vm._v("Mughamsayaghi")]), _vm._v(", excerpt. Performed by Kronos Quartet. Audio. Source: Kronos Quartet. Mugam Sayagi. Music of Franghiz Ali-Zadeh. Nonesuch Records Inc., 79804-2, 2005, compact disc.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910371",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910371")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.13"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.13 | Javanshir Guliyev, "), _c('em', [_vm._v("Seven Pieces in Mugham Modes")]), _vm._v(". Performed by Teymur Shamsiyev. Baku, 1980. Audio. Courtesy: Javanshir Guliyev.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910372",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910372")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur6.14"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 6.14 | Faraj Garayev, "), _c('em', [_vm._v("Khutba, Mugham, and Sura")]), _vm._v(", excerpt. Performed by Nieuw Ensemble (Amsterdam). Ed Spanjaard, conductor. Mohlat Muslumov, tar soloist. Amsterdam, Paradiso Concert Hall, February 3, 1998. Audio. Courtesy: Faraj Garayev and Ed Spanjaard.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910373",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910373")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("CHAPTER 7")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "pur7.1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 7.1 | Vasif Adigozalov, “Carnation,” Arrangement for the tar and chamber orchestra. Performed by Ramiz Guliyev and the Azerbaijan State Chamber Orchestra named after Gara Garayev. Yashar Imanov, conductor. Audio. Source: Classical Music of Azerbaijan, 6 vols. Vol. 1: Chamber Music. Track 10. Azerbaijan International, AICD1206, 1997, compact disc. Produced jointly by Amoco and Azerbaijan International. "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://azer.com/aiweb/categories/music/AudioPages/CMA/cma_contents.html",
      "target": "_blank"
    }
  }, [_vm._v("http://azer.com/aiweb/categories/music/AudioPages/CMA/cma_contents.html")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910374",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910374")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur7.2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 7.2 | Said Rustamov, “Where Are You?” Arranged by Rafig Babayev. Performed by Akif Islamzade and the Orchestra of the Azerbaijani Television and Radio. Baku, 1985. Video. Courtesy: Akif Islamzade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910375",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910375")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "pur7.3"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 7.3 | Tofig Guliyev, “Your Beauty Won’t Last Forever.” Performed by Rashid Behbudov and the Azerbaijan State Symphony Orchestra named after Uzeyir Hajibeyli. Niyazi, conductor. Courtesy: Rashida Behbudova. Audio. Source: Aida Huseynova, "), _c('em', [_vm._v("Music and Culture of Azerbaijan")]), _vm._v(", Global Voices Comprehensive (MJ & Associates, Inc., 2007), "), _c('span', {
    staticClass: "small"
  }, [_vm._v("DVD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910376",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910376")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur7.4"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 7.4 | Emin Sabitoghlu, “Tonight.” Performed by Huseynagha Hadiyev and Dan Ulduzu Ensemble. Gulara Aliyeva, artistic director. Baku, 1978. Video. Courtesy: Jeyran Mahmudova.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910377",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910377")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur7.5"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 7.5 | Telman Hajiyev, “Poppies.” Performed by Rashid Behbudov and the Ensemble of the Song Theater of Azerbaijan. Rafig Babayev, artistic director. Baku, 1975. Video. Courtesy: Rashida Behbudova.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910378",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910378")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur7.6"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 7.6. Muslim Magomayev, “Azerbaijan,” Performed by Muslim Magomayev and the Azerbaijan State Orchestra of Popular and Symphonic Music. Baku, 1980. Video. Courtesy: Marina Magomayeva and Tamara Siniavskaia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910379",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910379")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur7.7"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 7.7 | Chingiz Sadikhov. Improvisations. From the concert of the International Vocal Ensemble of Indiana University. Artistic Director Mary Goetze. Auer Hall, April 21, 2002. Audio. Courtesy: Indiana University Jacobs School of Music.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910380",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910380")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur7.8"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 7.8 | Azerbaijani folk song “Hey Flowersome.” Performed by the International Vocal Ensemble of Indiana University. Artistic Director Mary Goetze. Chingiz Sadikhov, pianist. Auer Hall, April 21, 2002. Audio. Courtesy: Indiana University Jacobs School of Music.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910381",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910381")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("CHAPTER 8")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "pur8.1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 8.1 | Ogtay Kazimi, “Life, You Are So Unpredictable.” Video clip directed by Eldar Guliyev. Baku, 1970. Video. Courtesy: Gaya group.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910382",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910382")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur8.2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 8.2 | Azerbaijani Folk Song “Look at Me.” Performed by the ensemble Beri Bakh, Artistic Director Rauf Babayev Recorded by Mary Goetze. Video. Source: "), _c('em', [_vm._v("Global Voices, Grade 5")]), _vm._v(", published by MJ & Associates. Coordinated with Spotlight on Music, Grade 5, published by McMillan McGraw Hill, Inc., 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910383",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910383")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "pur8.3"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 8.3 | Rafig Babayev, “In the Mode Bayati Kurd,” Baku, 1967. Audio. Courtesy: Fariza Babayeva.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910384",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910384")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur8.4"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 8.4 | Vagif Mustafazade, “Bayati Shiraz,” Audio. Courtesy: Afag Aliyeva. Source: Vagif Mustafazade. Baku: Vagif Mustafazade Foundation, 2004, compact disc. Track 4.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910385",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910385")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur8.5"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 8.5 | Vagif Mustafazade, Improvisation on the theme by Gara Garayev from the soundtrack for the film "), _c('em', [_vm._v("The Man Casts Anchor")]), _vm._v(". Baku, 1970. Audio. Courtesy: Afag Aliyeva.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910386",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910386")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur8.6"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 8.6 | Salman Gambarov, Soundtrack for the silent film "), _c('em', [_vm._v("Latif")]), _vm._v(", excerpt. Salman Gambarov, pianist, Fakhraddin Dadashov, kemancha, Natig Shirinov, percussions. Baku International Jazz Festival. Baku Jazz Center, April 10, 2005. Video. Courtesy: Salman Gambarov.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910387",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910387")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur8.7"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 8.7 | Salman Gambarov, Soundtrack for the silent film "), _c('em', [_vm._v("Latif")]), _vm._v(", excerpt. Salman Gambarov, pianist, Fakhraddin Dadashov, kemancha, Natig Shirinov, percussions. Baku International Jazz Festival. Baku Jazz Center, April 10, 2005. Video. Courtesy: Salman Gambarov.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910388",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910388")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur8.8"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 8.8 | Shahin Novrasli, "), _c('em', [_vm._v("I Went to the Garden to Pick Up Grape")]), _vm._v(". First Buta Festival of Azerbaijani Arts. London, Southbank Centre. Queen Elizabeth Hall. November 25, 2009. Video. Courtesy: Shahin Novrasli.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910389",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910389")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur8.9"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 8.9 | Emil Afrasiyab, "), _c('em', [_vm._v("Two Worlds")]), _vm._v(". Baku, the Heydar Aliyev Center. September 6, 2013. Video. Courtesy: Emil Afrasiyab.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910390",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910390")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur8.10"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 8.10 | Isfar Sarabski, "), _c('em', [_vm._v("Novruz")]), _vm._v(". Baku International Jazz Festival. The Azerbaijan State Philharmonic Hall named after Muslim Magomayev, October 19, 2010. Video. Courtesy: Isfar Sarabski.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910391",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910391")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("CHAPTER 9")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "pur9.1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 9.1 | "), _c('em', [_vm._v("Mugham Bayati Shiraz")]), _vm._v(". Performed by the ensemble Garabagh Nightingales, Artistic Director Murad Rzayev. Excerpt from the documentary Garabagh "), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v("Nightingales. Azerbaijanfilm Studio, 1977. Video. Courtesy: Azerbaijanfilm Studio.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910392",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910392")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur9.2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 9.2 | Murad Rustamzade performs "), _c('em', [_vm._v("mugham Murza Huseyn Segahi")]), _vm._v(" at the Children’s Eighth Mugham Festival, excerpt. Recorded by Aida Huseynova. Baku, The Song Theater named after Rashid Behbudov, October 22, 2003. Video. Courtesy: Kainat Youth Center.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910393",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910393")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur9.3"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 9.3 | "), _c('em', [_vm._v("Mugham Garabagh Shikastasi")]), _vm._v(". Arranged by Jeyhun Allahverdiyev. Performed by Nazaket Teymurova, Khari Bulbul mugham group, and the Azerbaijan State Chamber Orchestra named after Gara Garayev. Teymur Goychayev, conductor. Baku, the Heydar Aliyev Palace, December 19, 2009. Video. Courtesy: Teymur Goychayev.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910394",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910394")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur9.4"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 9.4 | Farhad Badalbeyli, "), _c('em', [_vm._v("Ave Maria")]), _vm._v(". Performed by Farida Mammadova and Gulnaz Ismayilova and the Azerbaijan State Symphony Orchestra of the Television and Radio. Azad Aliyev, conductor. Baku, 2009. Video. Courtesy: Farhad Badalbeyli.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910395",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910395")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur9.5"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 9.5 | Vasif Adigozalov, “Lullaby for Shusha,” Performed by Aygun Baylar and Murad Adigozalzade. The Fourth International Gabala Music Festival, July 27, 2012. Video. Courtesy: Yalchin Adigozalov.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910396",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910396")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur9.6"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 9.6 | Eldar Mansurov, “Bayatilar.” Performed by Brilliant Dadashova. Azerbaijan State Television and Radio, 1989. Video. Courtesy: Eldar Mansurov.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910397",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910397")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur9.7"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 9.7 | DJ Pantelis “I Have a Dream” Composer: Eldar Mansurov. Produced and remixed by DJ Pantelis. Video, 2008. "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.djpantelis.com",
      "target": "_blank"
    }
  }, [_vm._v("www.djpantelis.com")])]), _vm._v(", "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.facebook.com/djpantelisofficial",
      "target": "_blank"
    }
  }, [_vm._v("www.facebook.com/djpantelisofficial")])]), _vm._v(". Courtesy: DJ Pantelis and CEo/Sugar Factory Records.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910398",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910398")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur9.8"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 9.8 | Azerbaijani Folk Song “Fair Lady.” Performed by the State Ensemble of Ancient Music Instruments. Artistic Director and soloist Munis Sharifov. Baku, the International Mugham Center, May 5, 2012. Video. Courtesy: Munis Sharifov.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910399",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910399")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur9.9"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 9.9 | Jovdat Hajiyev, "), _c('em', [_vm._v("Ballade")]), _vm._v(". Performed by Murad Adigozalzade. Audio. Source: Murad Adigozalzade. "), _c('em', [_vm._v("Selections of Azerbaijani Piano Music")]), _vm._v(". Baku: Azercell, "), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v("2004. 2 Vols. Volume 1, Track 5.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910400",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910400")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur9.10"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 9.10 | Gara Garayev, Three Preludes. Performed by Murad Huseynov. Baku, the Azerbaijan National Art Museum, September 28, 2010. Audio. Courtesy: Murad Huseynov.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910401",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910401")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("CHAPTER 10")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "pur10.1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 10.1 | Uzeyir Hajibeyli, "), _c('em', [_vm._v("Layla and Majnun")]), _vm._v(", Chamber arrangement by the Silk Road Ensemble and Yo-Yo Ma, final episode. Recorded at the New College Theater, Harvard University. November 29, 2007. Video © Courtesy of Silkroad.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910402",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910402")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('a', {
    attrs: {
      "id": "pur10.2"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL")]), _vm._v(" 10.2 | Uzeyir Hajibeyli, "), _c('em', [_vm._v("Layla and Majnun")]), _vm._v(", Chamber arrangement by the Silk Road Ensemble and Yo-Yo Ma, part 2. Recorded at the New College Theater, Harvard University. November 29, 2007. Video © Courtesy of Silkroad.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910403",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910403")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("EPILOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "pure.1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PURL E")]), _vm._v(".1 | Said Rustamov, “Getme Getme” (Don’t Leave Don’t Leave), excerpt. Performed by Kronos Quartet, Alim Gasimov and Fargana Gasimova. Audio. Source: Kronos Quartet. Floodplain. Nonesuch Records Inc., 518349-2, 2009, 2014, compact disc.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://purl.dlib.indiana.edu/iudl/em/Huseynova/910404",
      "target": "_blank"
    }
  }, [_vm._v("http://purl.dlib.indiana.edu/iudl/em/Huseynova/910404")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d2be58f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 75
// module chunks = 0